import React from 'react';
import './styles/Projects.css';

const Projects = React.forwardRef((props, ref) => {
	return (
		<div name="projects" className="projects-container" ref={ref}>
			<div className="project-list">
				<ul>
					<form target="_blank" action="https://dark-office.vercel.app/">
						<li className="list-group-item">
							<div className="project-item">
								<div className="project-item-header">
									<img
										src="https://i.imgur.com/GRz3fLg.png"
										alt="Dark Office Logo"
										style={{ height: '2em', width: 'auto' }}
									/>
									<h4>Dark Office (Work in progress)</h4>
								</div>
								<li className="list-unstyled">
									<ul>
										<li>
											Built using Next.js, TypeScript, Tailwind CSS, and Framer
											Motion to deliver a dynamic, interactive user experience
											with smooth animations.
										</li>
										<li>
											Crafted a fully responsive layout that adapts seamlessly
											across devices, ensuring consistency and usability for all
											users.
										</li>
										<li>
											Developed for a real-world company focused on factory
											optimization, utilizing technologies like ENS, MES+, and
											MOM.
										</li>
										<li>
											Gained deep expertise in building scalable,
											production-ready applications, enhancing my proficiency in
											Next.js and interactive UI development with modern tools.
										</li>
									</ul>
								</li>
								<p>Typescript, React, Tailwind CSS, Node.js, Antd.</p>
								<button
									id="projectButton"
									type="submit"
									value="project"
									class="btn btn-outline-primary"
								>
									<span className="button-text">View Project</span>
									<span class="button-context">
										<svg
											aria-hidden="true"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="https://www.w3.org/2000/svg"
										>
											<path
												d="M6.75 17.25L1.5 12L6.75 6.75"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M12 4 L12 20"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M17.25 6.75L22.5 12L17.25 17.25"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</span>
								</button>
								<hr />
							</div>
						</li>
					</form>
					<form target="_blank" action="https://ertunametal.com/">
						<li className="list-group-item">
							<div className="project-item">
								<div className="project-item-header">
									<img
										src="https://i.imgur.com/CV6KLzi.png"
										alt="Ertuna Logo"
										style={{ height: '1em', width: 'auto' }}
									/>
									<h4>Ertuna Metal</h4>
								</div>
								<li className="list-unstyled">
									<ul>
										<li>
											Developed using modern technologies including Typescript,
											React, Tailwind CSS, Node.js, and Ant Design (Antd).
										</li>
										<li>
											Implemented a fully responsive design ensuring optimal
											user experience across all devices and screen sizes.
										</li>
										<li>
											This website is not a hobby project; it was developed for
											and is currently in use by an actual company, showcasing
											its real-world application and reliability.
										</li>
										<li>
											Significantly enhanced my expertise in Typescript and
											Tailwind CSS through the development of this project,
											furthering my proficiency in modern web development
											practices.
										</li>
									</ul>
								</li>
								<p>Typescript, React, Tailwind CSS, Node.js, Antd.</p>
								<button
									id="projectButton"
									type="submit"
									value="project"
									class="btn btn-outline-primary"
								>
									<span className="button-text">View Project</span>
									<span class="button-context">
										<svg
											aria-hidden="true"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="https://www.w3.org/2000/svg"
										>
											<path
												d="M6.75 17.25L1.5 12L6.75 6.75"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M12 4 L12 20"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M17.25 6.75L22.5 12L17.25 17.25"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</span>
								</button>
								<hr />
							</div>
						</li>
					</form>
					<form target="_blank" action="https://ecemertwedding.netlify.app/">
						<li className="list-group-item">
							<div className="project-item">
								<div className="project-item-header">
									<img
										src="https://i.imgur.com/YFodCnl.jpg"
										alt="E&M Logo"
										className="rounded-circle"
									/>
									<h4>Ece & Mert's Wedding Website</h4>
								</div>
								<li className="list-unstyled">
									<ul>
										<li>
											Executed frontend development using Typescript, React and
											Tailwind.
										</li>
										<li>
											Established a robust and intricate database system using
											MongoDB and serverless Netlify database function.
										</li>
										<li>
											Implemented a RSVP system where data is stored and reached
											from the MongoDB Atlas Database.
										</li>
										<li>
											Website is fully responsive and works on all devices.
										</li>
									</ul>
								</li>
								<p>
									HTML, CSS, JS, React, Typescript, MongoDB, Node.js, Tailwind
								</p>
								<button
									id="projectButton"
									type="submit"
									value="project"
									class="btn btn-outline-primary"
								>
									<span className="button-text">View Project</span>
									<span class="button-context">
										<svg
											aria-hidden="true"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="https://www.w3.org/2000/svg"
										>
											<path
												d="M6.75 17.25L1.5 12L6.75 6.75"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M12 4 L12 20"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M17.25 6.75L22.5 12L17.25 17.25"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</span>
								</button>
								<hr />
							</div>
						</li>
					</form>
					<form target="_blank" action="https://project-luis.netlify.app">
						<li className="list-group-item">
							<div className="project-item">
								<div className="project-item-header">
									<img src="https://i.imgur.com/RfbGfPq.png" alt="LUIS Logo" />
									<h4>Project L.U.I.S.</h4>
								</div>
								<li className="list-unstyled">
									<ul>
										<li>
											Executed frontend development using HTML, CSS, JS, and
											React.
										</li>
										<li>
											Established a robust and intricate database system using
											MongoDB, Express.js, Node.js,and Postman.
										</li>
										<li>
											Crafted both the backend and frontend from the ground up.
										</li>
										<li>Implemented a secure user authentication system.</li>
										<li>
											Empowered users to review their bootcamps and modules,
											while granting admincapabilities for CRUD operations
											throughout the website.
										</li>
									</ul>
								</li>
								<p>HTML, CSS, JS, React, MongoDB, Express.js, Node.js</p>
								<button
									id="projectButton"
									type="submit"
									value="project"
									class="btn btn-outline-primary"
								>
									<span className="button-text">View Project</span>
									<span class="button-context">
										<svg
											aria-hidden="true"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="https://www.w3.org/2000/svg"
										>
											<path
												d="M6.75 17.25L1.5 12L6.75 6.75"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M12 4 L12 20"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M17.25 6.75L22.5 12L17.25 17.25"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</span>
								</button>
								<hr />
							</div>
						</li>
					</form>
					<form target="_blank" action="https://rate-my-stuff.netlify.app/">
						<li className="list-group-item">
							<div className="project-item">
								<div className="project-item-header">
									<img
										src="https://i.imgur.com/n2Fke6x.png"
										alt="Rate My Stuff Logo"
									/>
								</div>
								<li className="list-unstyled">
									<ul>
										<li>
											Contributed to this project using HTML, CSS, JS, and
											React.
										</li>
										<li>
											Implemented basic server functionalities with Node.js and
											a JSON API.
										</li>
										<li>
											Enabled users to perform CRUD operations on posts,
											comments, and star-ratings.
										</li>
									</ul>
								</li>
								<p>HTML, CSS, JS, React, MongoDB, Express.js, React, Node.js</p>
								<button
									id="projectButton"
									type="submit"
									value="project"
									class="btn btn-outline-primary"
								>
									<span className="button-text">View Project</span>
									<span class="button-context">
										<svg
											aria-hidden="true"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="https://www.w3.org/2000/svg"
										>
											<path
												d="M6.75 17.25L1.5 12L6.75 6.75"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M12 4 L12 20"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M17.25 6.75L22.5 12L17.25 17.25"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</span>
								</button>
								<hr />
							</div>
						</li>
					</form>
					<form
						target="_blank"
						action="https://eminmerttoprak.github.io/mert-toprak-first-game/"
					>
						<li className="list-group-item">
							<div className="project-item">
								<div className="project-item-header">
									<img
										src="https://i.imgur.com/arvzLxt.png"
										alt="Console Frog Logo"
									/>
									<h4>Console.frog</h4>
								</div>
								<li className="list-unstyled">
									<ul>
										<li>
											Developed a game inspired by the classic Frogger from
											1982, utilizing vanilla JS, DOM, and fundamental CSS
											skills acquired in the initial two weeks of the course.
										</li>
									</ul>
								</li>
								<p>HTML, CSS, JS</p>
								<button
									id="projectButton"
									type="submit"
									value="project"
									class="btn btn-outline-primary"
								>
									<span className="button-text">View Project</span>
									<span class="button-context">
										<svg
											aria-hidden="true"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="https://www.w3.org/2000/svg"
										>
											<path
												d="M6.75 17.25L1.5 12L6.75 6.75"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M12 4 L12 20"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path
												d="M17.25 6.75L22.5 12L17.25 17.25"
												stroke="black"
												stroke-width="1.5"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</span>
								</button>
							</div>
						</li>
					</form>
				</ul>
			</div>
		</div>
	);
});

export default Projects;
